import { FC } from 'react';
import { Footer } from 'layouts/Footer';
import Header from 'layouts/Header';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getIsAuth, getMerchantId } from 'redux/reducers/auth/selectors';
import { saveUrl } from 'redux/reducers/auth/reducer';
import { Helmet } from 'react-helmet-async';
import { TPageProps } from './types';

// ==========================================:
export const Page: FC<TPageProps> = ({ children, title }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const ifAuth = useSelector(getIsAuth);

	if (!ifAuth) {
		const url =
			window.location.pathname === '/sign-in'
				? '/shops'
				: window.location.pathname + window.location.search;

		dispatch(saveUrl(url));
		navigate('/');
	}

	return (
		<div className="wrapper">
			<Helmet>
				<title>{title}</title>
			</Helmet>

			<Header />
			<main className="main">
				<div className="main-content">{children}</div>
			</main>
			<Footer />
		</div>
	);
};
